export default {
    //common
    SET_ANALYZE_ERROR: "setAnalyzeError",

    SET_EVENT_COUPON_NAME: "setEventCouponName",
    SET_EVENT_COUPON_RESET: "setEventCouponReset",
    SET_MANUAL_COUPON_INFO: "setManualCouponInfo",
    SET_MANUAL_COUPON_INFO_DEFAULT: "setManualCouponInfoDefault",
}

export const initialCouponInfoState = {
    price: 0,
    eventName: null,
    applyType: null,
  };
export const initialManualCouponInfoState = {
    /** @type {string | null} 쿠폰 코드 */
    codeToken: null,
  
    /** @type {number | null} 할인 금액 */
    discount: null,
  
    /** @type {number | null} 최종 결제 금액 */
    finalPrice: null,
  
    /** @type {boolean | null} 유효 여부 */
    isValid: null,
  
    /** @type {string | null} 메시지 */
    message: null,
  };